"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PonziReport = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const x_data_grid_1 = require("@mui/x-data-grid");
const react_intl_1 = require("react-intl");
const date_fns_1 = require("date-fns");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const types_collection_1 = require("@dzambalaorg/types-collection");
const exchange_1 = require("@framework/exchange");
const types_1 = require("@framework/types");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const schemas_1 = require("./schemas");
const search_1 = require("./search");
const PONZI_REPORT_URL = "/ponzi/report";
const PonziReport = (props) => {
    const { service } = props;
    const { isLoading, take, skip, onChangePage, allRows, totalCount } = (0, react_hooks_1.useFetchQuery)(PONZI_REPORT_URL, void 0, void 0, {
        contractId: types_collection_1.InputType.awaited,
        ponziDepositStatus: [types_1.PonziDepositStatus.ACTIVE],
        deposit: {
            tokenType: types_1.TokenType.ERC20,
            contractId: types_collection_1.InputType.awaited,
        },
        reward: {
            tokenType: types_1.TokenType.ERC20,
            contractId: types_collection_1.InputType.awaited,
        },
        startTimestamp: (0, date_fns_1.startOfMonth)((0, date_fns_1.subMonths)(new Date(), 1)).toISOString(),
        endTimestamp: (0, date_fns_1.endOfMonth)((0, date_fns_1.addMonths)(new Date(), 1)).toISOString(),
    });
    const { formatMessage } = (0, react_intl_1.useIntl)();
    // TODO - [AFTER ALL REFACTORING] - check possibility to return search values from useFetchQuery
    // const { fn } = useApiCall(async (api, values) => {
    //   return api.fetchFile({
    //     url: "/ponzi/report/export",
    //     data: values,
    //   });
    // });
    const handleExport = () => {
        // return fn(void 0, search);
        return Promise.resolve();
    };
    const columns = (0, schemas_1.columnsCreator)(formatMessage);
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, { children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.Breadcrumbs, { path: ["dashboard", "ponzi", "ponzi.report"] }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: "pages.ponzi.report.title", children: (0, jsx_runtime_1.jsx)(ui_kit_1.Button, { startIcon: (0, jsx_runtime_1.jsx)(icons_material_1.CloudDownload, {}), onClick: handleExport, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "form.buttons.export" }) }) }), (0, jsx_runtime_1.jsx)(search_1.PonziSearchForm, { service: service }), (0, jsx_runtime_1.jsx)(x_data_grid_1.DataGrid, { pagination: true, paginationMode: "server", rowCount: totalCount, paginationModel: { page: skip / take, pageSize: take }, onPaginationModelChange: ({ page }) => onChangePage({}, page), pageSizeOptions: [5, 10, 25], loading: isLoading, columns: columns, rows: allRows.map((stake) => ({
                    id: stake.id,
                    account: stake.account,
                    deposit: (0, exchange_1.formatItem)(stake.ponziRule?.deposit),
                    ponziRule: stake.ponziRule.title,
                    createdAt: stake.createdAt,
                })) })] }));
};
exports.PonziReport = PonziReport;
//# sourceMappingURL=index.js.map